document.addEventListener('DOMContentLoaded', () => {
  const countdowns = document.querySelectorAll('.launch-countdown');

  countdowns.forEach((countdown) => {
    const launchDateValue = countdown.dataset.launchDate;

    if (!launchDateValue) return;

    const launchDate = new Date(launchDateValue).getTime();

    const daysElement = countdown.querySelector('#launch-days');
    const hoursElement = countdown.querySelector('#launch-hours');
    const minutesElement = countdown.querySelector('#launch-minutes');
    const secondsElement = countdown.querySelector('#launch-seconds');

    if (
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement ||
      Number.isNaN(launchDate)
    ) {
      return;
    }

    const updateCountdown = () => {
      const distance = launchDate - Date.now();

      if (distance <= 0) {
        countdown.remove();
        window.location.reload();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor(
        (distance % (1000 * 60)) / 1000
      );

      daysElement.textContent = String(days).padStart(2, '0');
      hoursElement.textContent = String(hours).padStart(2, '0');
      minutesElement.textContent = String(minutes).padStart(2, '0');
      secondsElement.textContent = String(seconds).padStart(2, '0');
    };

    updateCountdown();

    const countdownInterval = setInterval(updateCountdown, 1000);

    window.addEventListener(
      'beforeunload',
      () => clearInterval(countdownInterval),
      { once: true }
    );
  });
});